import { Feature } from '@nirvana/shared/constants';

export interface ReconfigureAgentViewData {
  companyId: string;
  availableFeatures: Feature[];
}

export enum ReconfigureAgentPanelEvent {
  OnReconfigureAgentModulesChanged = 'onReconfigureAgentModulesChanged',
}

export class OnReconfigureAgentModuleIsChecked extends CustomEvent<{ allModulesUnchecked: boolean }> {
  constructor(allModulesUnchecked: boolean) {
    super(ReconfigureAgentPanelEvent.OnReconfigureAgentModulesChanged, {
      detail: {
        allModulesUnchecked,
      },
      bubbles: true,
      composed: true,
    });
  }
}
